import React from "react";
import { Box, HStack, Text, Tooltip, VStack } from "@chakra-ui/react";
import { useVizTokens } from "./tokens";
import { count, money } from "./format";

// What texts of each length cost: 1, 2, 3–5, 6–10 and 11+ segments. The lengths are ordered, so
// the columns take one hue, darker for longer. The cost sits on each column's cap; the number of
// texts under its label.
export default function SegmentColumns({ buckets, height = 170 }) {
  const t = useVizTokens();
  const max = Math.max(0, ...(buckets || []).map((b) => b.cost || 0));
  return (
    <Box>
      <HStack align="flex-end" justify="space-around" h={`${height + 22}px`} borderBottomWidth="1px"
              borderColor={t.baseline} px={2}>
        {(buckets || []).map((b, i) => {
          const h = max > 0 ? Math.max(2, ((b.cost || 0) / max) * height) : 0;
          const words = `${b.label} segment${b.label === "1" ? "" : "s"}: ${count(b.texts)} texts · ${money(b.cost)}`;
          return (
            <Tooltip key={b.key} label={words} hasArrow openDelay={80}>
              <VStack spacing={1} justify="flex-end" h="100%" tabIndex={0} aria-label={words} px={2}
                      borderRadius="md" _hover={{ bg: t.hover }}
                      _focusVisible={{ outline: "2px solid", outlineColor: t.series[0] }}>
                <Text fontSize="xs" fontWeight="semibold" color={t.text}>{money(b.cost)}</Text>
                <Box w="24px" h={`${h}px`} bg={t.ordinal[i] || t.ordinal[t.ordinal.length - 1]} borderTopRadius="4px" />
              </VStack>
            </Tooltip>
          );
        })}
      </HStack>
      <HStack justify="space-around" px={2} mt={1.5}>
        {(buckets || []).map((b) => (
          <VStack key={b.key} spacing={0} minW="48px">
            <Text fontSize="xs" color={t.text}>{b.label}</Text>
            <Text fontSize="xs" color={t.muted}>{count(b.texts)} texts</Text>
          </VStack>
        ))}
      </HStack>
    </Box>
  );
}
